module.exports = __webpack_public_path__ + "img/cart.a67dc02a.svg";